import Styles from './ActiveColorsIndicator.module.scss'
import cx from 'classnames'

import { memo } from 'react'

interface Props {
  colors: string[]
  className?: string
  type?: 'text' | 'other'
}

export const ActiveColorsIndicator = memo(({ colors, className, type = 'other' }: Props) => {
  return (
    <div className={cx(Styles.activeColorsContainer, className)}>
      {colors.map((color) => (
        <div
          style={{ background: color }}
          className={cx(Styles.activeColor, { [Styles.backgroundActiveColor]: type === 'other' })}
          key={color}
        />
      ))}
    </div>
  )
})
